import { Image, Text, View, StyleSheet } from "@react-pdf/renderer";

const styles = StyleSheet.create({
  h2: {
    fontSize: 14,
    lineHeight: 1.4,
    fontWeight: 600,
    marginBottom: 0,
  },
  chart: {
    display: "flex",
    flexDirection: "column",
    gap: 6,
  },
  image: {
    width: "100%",
    minHeight: 200,
    objectFit: "contain",
  },
  placeholder: {
    fontSize: 10,
    color: "#666",
  },
});

export const ChartRenderer = ({ screenshot, title, style }) => {
  return (
    <View style={[styles.chart, style]} wrap={false}>
      <Text style={styles.h2}>{title}</Text>

      {screenshot ? (
        <Image src={screenshot} style={styles.image} />
      ) : (
        <Text style={styles.placeholder}>
          Данные диаграммы подготовлены, скриншот недоступен.
        </Text>
      )}
    </View>
  );
};
